// Utilidades de geolocalización compartidas.
// En la base de datos conviven varios formatos de coordenadas:
//   { lat, lng } (tiendas y direcciones), { latitude, longitude } (ubicación del usuario),
//   { latitud, longitud } (datos antiguos) y GeoPoint de Firestore.

export const RADIO_CERCA_KM = 50;

export const normalizarCoordenadas = (c) => {
  if (!c || typeof c !== "object") return null;
  const lat = Number(c.lat ?? c.latitude ?? c.latitud);
  const lng = Number(c.lng ?? c.lon ?? c.longitude ?? c.longitud);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
};

const aRad = (g) => (g * Math.PI) / 180;

// Distancia en km (haversine). Devuelve Infinity si alguna coordenada no es válida.
export const distanciaKm = (a, b) => {
  const p1 = normalizarCoordenadas(a);
  const p2 = normalizarCoordenadas(b);
  if (!p1 || !p2) return Infinity;
  const dLat = aRad(p2.lat - p1.lat);
  const dLng = aRad(p2.lng - p1.lng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(aRad(p1.lat)) * Math.cos(aRad(p2.lat)) * Math.sin(dLng / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
};

export const formatearDistancia = (km) => {
  if (!Number.isFinite(km)) return "";
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(km < 10 ? 1 : 0)} km`;
};
